module.exports = __webpack_public_path__ + "static/media/creditIcon.06d00639.svg";